import { SelectService } from '../services/select.service';

export class SelectableItem {
  public _selected = false;
  public _childSelected = false;
  public children: SelectableItem[] = [];
  public isOpen = false;
  public matchFilter = true;
  public isVisible = false;

  constructor(public id: string, public text: string, public data: any, public svc: SelectService) {
  }

  get hasChild(): boolean {
    return this.children != undefined && this.children.length > 0;
  }
  get checked(): boolean {
    if (this.hasChild && this.svc.Configuration.allowMultiple) {
      if (this.children?.every((child) => child.selected)) {
        // if (this.text === "Select All") {
        //   console.log("current obj 1 ===> ",this)
        // }
        return true;
      } else if (this.children?.every((child) => child.selected === false)) {
        // if (this.text === "Select All") {
        //   console.log("current obj 2 ===> ",this)
        // }
        return this._selected;
      }
      return false;
    }
    return this._selected;
  }
  get selected(): boolean {
    if (this.hasChild && this.svc.Configuration.allowMultiple) {
      if (this.children?.every((child) => child.selected)) {
        // if (this.children?.some((child) => child.selected)) {
        if (this.svc.Configuration.allowParentSelection) {
          this._selected = false;
        }
        return true;
        // if (this.text === "Select All") {
        //   console.log("******** in Select All ********")
        //   if (this.children?.every((child) => child.selected)) {
        //     console.log("******** in Select All every select true ********")
        //     return true;
        //   }else{
        //     console.log("******** in Select All every select false ********")
        //     return false;
        //   }
        // }else{
        //   console.log("******** out Select All ********")
        //   return true;
        // }
      } else if (this.children?.every((child) => child.selected === false)) {
        if (this.svc.Configuration.allowParentSelection) {
          return this._selected;
        } else {
          return this._selected = false;
        }
      }
      return false;
    } else if (this.hasChild && this._selected === true) {
      this.children?.forEach((itm) => itm.selected = false);
      /*for (const itm of this.children) {
        itm.selected = false;
      }*/
    }
    return this._selected;
  }
  set selected(value: boolean) {
    // console.log("child.selected",value)
    if (this.hasChild && !this.svc.Configuration.allowParentSelection) {
      if (value !== null) {
        this.children?.forEach((child) => child.selected = value);
      }
    } else {
      this._selected = value;
      // this._childSelected = value;
    }
  }

}
